import { render, staticRenderFns } from "./customersTag.vue?vue&type=template&id=53073683&scoped=true"
import script from "./customersTag.vue?vue&type=script&lang=js"
export * from "./customersTag.vue?vue&type=script&lang=js"
import style0 from "./customersTag.vue?vue&type=style&index=0&id=53073683&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53073683",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53073683')) {
      api.createRecord('53073683', component.options)
    } else {
      api.reload('53073683', component.options)
    }
    module.hot.accept("./customersTag.vue?vue&type=template&id=53073683&scoped=true", function () {
      api.rerender('53073683', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/customersTag.vue"
export default component.exports